<div class="main-container">
    <div>
        <h2>Success</h2>
        <p>{{pleaseWait}} Redirecting</p>
    </div>
</div>
